'use client';

import React from 'react';
import { motion } from 'framer-motion';

export default function CTASection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-8 bg-background">
      <div className="max-w-7xl mx-auto">
        <motion.div
          className="relative overflow-hidden bg-primary dark:bg-card rounded-3xl p-8 md:p-14 shadow-strong border border-border"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          {/* Background pattern */}
          <div
            className="absolute inset-0 opacity-5 pointer-events-none"
            style={{
              backgroundImage: `radial-gradient(circle at 1px 1px, currentColor 1px, transparent 0)`,
              backgroundSize: '32px 32px',
            }}
          />
          {/* Shimmer */}
          <div className="absolute inset-0 shimmer-effect pointer-events-none" />

          <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            <div>
              <span className="text-xs uppercase tracking-widest text-accent font-semibold mb-4 block">
                Mulai Sekarang
              </span>
              <h2 className="text-display font-bold text-white dark:text-foreground leading-tight mb-4">
                Siap Wujudkan
                <br />
                <span className="text-accent">Proyek Anda?</span>
              </h2>
              <p className="text-white/70 dark:text-muted-foreground text-base leading-relaxed max-w-md">
                Hubungi kami sekarang untuk konsultasi gratis. Tim ahli kami siap membantu Anda
                memilih material, teknik, dan desain terbaik sesuai kebutuhan dan anggaran.
              </p>
            </div>

            <div className="flex flex-col gap-4">
              <div className="bg-white/10 dark:bg-muted/40 backdrop-blur-sm rounded-2xl p-5 border border-white/20 dark:border-border">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full bg-green-500/20 flex items-center justify-center">
                    <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5 text-green-400">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-white/60 dark:text-muted-foreground text-xs uppercase tracking-wider">
                      WhatsApp
                    </p>
                    <p className="text-white dark:text-foreground font-semibold">+62 813-2282-297</p>
                  </div>
                </div>
                <a
                  href="https://wa.me/628132282297?text=Halo%20IndoCuttingLaser%2C%20saya%20ingin%20konsultasi%20proyek"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full text-center py-4 px-6 rounded-xl bg-green-500 hover:bg-green-400 text-white font-semibold text-sm transition-all duration-300 hover:-translate-y-0.5 shadow-green-glow"
                >
                  Chat WhatsApp Sekarang
                </a>
              </div>

              <div className="grid grid-cols-3 gap-3">
                {[
                  { label: 'Respon', value: '< 1 Jam' },
                  { label: 'Pengiriman', value: '1-3 Hari' },
                  { label: 'Garansi', value: '100%' },
                ]?.map((stat, i) => (
                  <div
                    key={i}
                    className="bg-white/10 dark:bg-muted/30 rounded-xl p-3 text-center border border-white/10 dark:border-border"
                  >
                    <p className="text-accent font-bold text-sm">{stat?.value}</p>
                    <p className="text-white/50 dark:text-muted-foreground text-xs mt-0.5">
                      {stat?.label}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
